__turbopack_context__.v({
  "button2": "vL7E1G_button2",
  "company": "vL7E1G_company",
  "contactForm": "vL7E1G_contactForm",
  "desc": "vL7E1G_desc",
  "desc2": "vL7E1G_desc2",
  "desc3": "vL7E1G_desc3",
  "desc4": "vL7E1G_desc4",
  "desc5": "vL7E1G_desc5",
  "desc6": "vL7E1G_desc6",
  "desc7": "vL7E1G_desc7",
  "desc8": "vL7E1G_desc8",
  "desc9": "vL7E1G_desc9",
  "dialogClose": "vL7E1G_dialogClose",
  "email": "vL7E1G_email",
  "emailErrorContainer": "vL7E1G_emailErrorContainer",
  "emailInput": "vL7E1G_emailInput",
  "emailLabel": "vL7E1G_emailLabel",
  "emailProvider": "vL7E1G_emailProvider",
  "error": "vL7E1G_error",
  "error2": "vL7E1G_error2",
  "error3": "vL7E1G_error3",
  "error5": "vL7E1G_error5",
  "error6": "vL7E1G_error6",
  "fill": "vL7E1G_fill",
  "footer": "vL7E1G_footer",
  "form": "vL7E1G_form",
  "formModal": "vL7E1G_formModal",
  "header": "vL7E1G_header",
  "icon2": "vL7E1G_icon2",
  "icon3": "vL7E1G_icon3",
  "icon4": "vL7E1G_icon4",
  "icon5": "vL7E1G_icon5",
  "img__guQs": "vL7E1G_img__guQs",
  "img__onE5R": "vL7E1G_img__onE5R",
  "img__pwiLs": "vL7E1G_img__pwiLs",
  "inputsRow": "vL7E1G_inputsRow",
  "institution": "vL7E1G_institution",
  "institutionErrorContainer": "vL7E1G_institutionErrorContainer",
  "institutionInput": "vL7E1G_institutionInput",
  "institutionLabels": "vL7E1G_institutionLabels",
  "institutionPhoneCol": "vL7E1G_institutionPhoneCol",
  "institutionProvider": "vL7E1G_institutionProvider",
  "intro": "vL7E1G_intro",
  "label10": "vL7E1G_label10",
  "label4": "vL7E1G_label4",
  "label5": "vL7E1G_label5",
  "label6": "vL7E1G_label6",
  "label7": "vL7E1G_label7",
  "label8": "vL7E1G_label8",
  "layout112": "vL7E1G_layout112",
  "left": "vL7E1G_left",
  "link": "vL7E1G_link",
  "link__bzIj5": "vL7E1G_link__bzIj5",
  "link__flqLt": "vL7E1G_link__flqLt",
  "link__go6Jr": "vL7E1G_link__go6Jr",
  "link__kugEl": "vL7E1G_link__kugEl",
  "link__mliyE": "vL7E1G_link__mliyE",
  "link__qvVkD": "vL7E1G_link__qvVkD",
  "link__rtLxE": "vL7E1G_link__rtLxE",
  "message": "vL7E1G_message",
  "messageErrorContainer": "vL7E1G_messageErrorContainer",
  "messageLabel": "vL7E1G_messageLabel",
  "messageProvider": "vL7E1G_messageProvider",
  "messageTextarea": "vL7E1G_messageTextarea",
  "modalCloseButton": "vL7E1G_modalCloseButton",
  "name": "vL7E1G_name",
  "nameErrorContainer": "vL7E1G_nameErrorContainer",
  "nameInput": "vL7E1G_nameInput",
  "nameLabel": "vL7E1G_nameLabel",
  "nameProvider": "vL7E1G_nameProvider",
  "nameWorkCol": "vL7E1G_nameWorkCol",
  "paragraph": "vL7E1G_paragraph",
  "paragraph2": "vL7E1G_paragraph2",
  "paragraph3": "vL7E1G_paragraph3",
  "phone": "vL7E1G_phone",
  "phoneErrorContainer": "vL7E1G_phoneErrorContainer",
  "phoneInput": "vL7E1G_phoneInput",
  "phoneProvider": "vL7E1G_phoneProvider",
  "sales": "vL7E1G_sales",
  "send": "vL7E1G_send",
  "sendMessageBtn": "vL7E1G_sendMessageBtn",
  "spinnerIcon": "vL7E1G_spinnerIcon",
  "support": "vL7E1G_support",
  "svg___7GFtB": "vL7E1G_svg___7GFtB",
  "svg__bIMws": "vL7E1G_svg__bIMws",
  "svg__cjTlV": "vL7E1G_svg__cjTlV",
  "svg__gw4Rc": "vL7E1G_svg__gw4Rc",
  "svg__nwEcm": "vL7E1G_svg__nwEcm",
  "svg__osSyw": "vL7E1G_svg__osSyw",
  "svg__pIs5C": "vL7E1G_svg__pIs5C",
  "svg__qsDjn": "vL7E1G_svg__qsDjn",
  "svg__zwRad": "vL7E1G_svg__zwRad",
  "text": "vL7E1G_text",
  "text8": "vL7E1G_text8",
  "text9": "vL7E1G_text9",
  "text___2ZFhw": "vL7E1G_text___2ZFhw",
  "text__invbI": "vL7E1G_text__invbI",
  "title": "vL7E1G_title",
  "title2": "vL7E1G_title2",
  "title4": "vL7E1G_title4",
  "title5": "vL7E1G_title5",
  "top": "vL7E1G_top",
});
